module.exports = __webpack_public_path__ + "static/media/K.2d0f1b3d.svg";